// Our modules / classes
// Import modules e.g import MobileMenu from "./modules/MobileMenu"
// import TestModule from './modules/TestModule'
import NavControl from './modules/NavControl'
import CollapsePanel from './modules/CollapsePanel'

// Instantiate a new object using our modules/classes
// e.g var mobileMenu =  new MobileMenu()

// var testModule = new TestModule()
var navControl = new NavControl()
var collapsePanel = new CollapsePanel()
